// @flow

import {havePermission} from "./utils"

export default class CartModifiersPermissions {

  canRead(proRole: ProRole = null): boolean {
    return havePermission(
      'restaurantMenu.cartModifiers',
      proRole
    )
  }

  canEdit(proRole: ProRole = null): boolean {
    return havePermission(
      'restaurantMenu.cartModifiers.canEdit',
      proRole
    )
  }
}
